import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-diagnosis-expand",
  "use": "app-icon-diagnosis-expand-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-diagnosis-expand\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M1 2h4v4H1zM2.25 6.5h1.5v8.647h-1.5z\" /><path d=\"M10.261 7.873v1.5H2.598v-1.5zM10.262 12.898v1.5H2.598v-1.5z\" /><path d=\"M10.053 7.123h3v3h-3zM10.053 12.147h3v3h-3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol